/** Plural helpers for the authored plan-details languages. */
/** Russian: 1 год / 2 года / 5 лет. */
export function ruPlural(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10
  const m100 = n % 100
  if (m10 === 1 && m100 !== 11) return one
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few
  return many
}
/** Arabic: counted noun forms for 1, 2, 3–10 and 11+ (0 takes the 11+ form). */
export function arPlural(n: number, one: string, two: string, few: string, many: string): string {
  if (n === 1) return one
  if (n === 2) return two
  const m100 = n % 100
  if (m100 >= 3 && m100 <= 10) return few
  return many
}

